import { createPortal } from 'react-dom';
import useNotifyStore from 'stores/notifyStore';
import { v4 as uuidv4 } from 'uuid';

const ToastManager = () => {
  const { currentToast } = useNotifyStore();

  return (
    <>
      {createPortal(
        <div
          key={uuidv4()}
          className="block fixed bottom-[30px] right-[30px] pointer-events-none z-30"
        >
          {currentToast}
        </div>,
        document.body
      )}
    </>
  );
};

export default ToastManager;
